<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du compte</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Prénom" :value="first_name" disabled/>
            <c-input container-class="mb-3" label="Nom" :value="last_name" disabled/>
            <c-input container-class="mb-3" label="Identifiant" :value="username" disabled/>
            <c-input container-class="mb-3" label="Numéro de téléphone" :value="phone_number" disabled/>
            <c-input container-class="mb-3" label="Adresse email" :value="email" disabled/>
            <c-input type="date" container-class="mb-3" label="Date d'inscription" :value="created_at" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input type="price" currency="XAF" container-class="mb-3" label="Solde du compte" :value="balance"
                     disabled/>
            <c-input type="date" container-class="mb-3" label="Date de naissance" v-model="birth_date" disabled/>
            <c-input type="date" container-class="mb-3" label="Date d'exp. de la pièce d'identité"
                     v-model="identity_expire_date" disabled/>
            <d-form-checkbox v-model="enabled">
              Compte activé
            </d-form-checkbox>
            <d-form-checkbox v-model="verified">
              Identité vérifiée
            </d-form-checkbox>
            <d-form-checkbox v-for="role in roleList" :key="role.id" v-model="roles" name="roles" :value="role.id">
              Rôle {{ role.name }}
            </d-form-checkbox>
          </d-col>
        </d-form-row>
        <c-table class="mt-3" :fetching="false" :table-data="verificationData" :fields="verificationFields">
          <p class="text-center" slot="empty">Aucun code de vérification.</p>
        </c-table>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="exportModalVisible" size="lg" @close="onExportModalClose">
      <d-modal-header>
        <d-modal-title>Exporter les transactions du compte</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col cols="6" class="pr-3 border-right">
            <c-input label="Nom du compte" :value="name" disabled/>
            <c-input type="select" label="Format d'export" :options="exportFormatOptions" v-model="export_format"/>
            <c-input type="select" label="Séparateur" :options="exportDelimiterOptions" v-model="export_delimiter"/>
            <c-input
              type="filename" label="Nom du fichier" placeholder="Nom du fichier"
              v-model="export_filename" :extension="export_extension" :state="export_filename_state"
            >
              Veuillez saisir un nom de fichier valide
            </c-input>
          </d-col>
          <d-col cols="6" class="pl-3">
            <c-input type="select" label="Transactions à exporter" :options="exportTransactionTypeOptions"
                     v-model="export_transaction_type"/>
            <c-input type="select" label="Statuts à exporter" :options="exportTransactionStatusOptions"
                     v-model="export_transaction_status"/>
            <c-input type="datetime" label="Depuis le (inclus)" v-model="export_from_datetime"
                     :state="export_from_datetime_state">
              Veuillez entrer la date et l'heure de début
            </c-input>
            <c-input type="datetime" label="Jusqu'au (inclus)" v-model="export_to_datetime"
                     :state="export_to_datetime_state">
              Veuillez entrer la date et l'heure de fin
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onExportFormSubmit"
                          v-if="!selectedItem.deleted">
          <template slot="icon">
            <i class="fa fa-download"></i>
          </template>
          Télécharger
        </c-button-spinner>
        <b-button variant="secondary" @click="onExportModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
        <vue-json-csv
          ref="csv" :data="export_data" :name="export_filename + export_extension"
          :delimiter="export_delimiter"
        >
          <span></span>
        </vue-json-csv>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="settingsModalVisible" size="lg" @close="onSettingsModalClose">
      <d-modal-header>
        <d-modal-title>Paramètres du compte de "{{ name }}"</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div v-if="fetchingAccountSettings" class="text-center">
          <b-spinner/>
          <br>
          Récupération des paramètres du compte...
        </div>
        <div v-else>
          <d-form-row class="mb-5">
            <d-col class="pr-3">
              <c-input type="select" label="Paramétrer à partir d'un template ?"
                       :options="account_parameters_templates" v-model="account_parameters_template">
                <template slot="first">
                  <option :value="null">Sélectionnez un template</option>
                </template>
              </c-input>
            </d-col>
            <d-col class="ml-2">
              <c-input label="Template de base de ce compte" :value="user_account_parameters_name" disabled/>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col class="pr-3 border-right">
              <c-input type="price" currency="XAF" container-class="mb-3" label="Rechage - Montant maximal"
                       placeholder="Ex: 500" v-model="max_deposit_amount" :state="max_deposit_amountState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Rechage - Volume maximal / jour"
                       placeholder="Ex: 50000" v-model="max_deposit_amount_per_day"
                       :state="max_deposit_amount_per_dayState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="number" container-class="mb-3" label="Rechage - Nombre maximal / jour"
                       placeholder="Ex: 3" v-model="max_deposit_per_day" :state="max_deposit_per_dayState">
                Veuillez saisir un nombre entier
              </c-input>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Transfert - Montant maximal"
                       placeholder="Ex: 500" v-model="max_transfer_amount" :state="max_transfer_amountState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Transfert - Volume maximal / jour"
                       placeholder="Ex: 50000" v-model="max_transfer_amount_per_day"
                       :state="max_transfer_amount_per_dayState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="number" container-class="mb-3" label="Transfert - Nombre maximal / jour"
                       placeholder="Ex: 3" v-model="max_transfer_per_day" :state="max_transfer_per_dayState">
                Veuillez saisir un nombre entier
              </c-input>
            </d-col>
            <d-col class="ml-2">
              <c-input type="price" currency="XAF" container-class="mb-3" label="Retrait - Montant maximal"
                       placeholder="Ex: 500" v-model="max_withdrawal_amount" :state="max_withdrawal_amountState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Retrait - Volume maximal / jour"
                       placeholder="Ex: 50000" v-model="max_withdrawal_amount_per_day"
                       :state="max_withdrawal_amount_per_dayState">
                Veuillez saisir un montant
              </c-input>
              <c-input type="number" container-class="mb-3" label="Retrait - Nombre maximal / jour"
                       placeholder="Ex: 3" v-model="max_withdrawal_per_day" :state="max_withdrawal_per_dayState">
                Veuillez saisir un nombre entier
              </c-input>
              <d-form-checkbox v-model="deposit_enabled">
                Recharge autorisée
              </d-form-checkbox>
              <d-form-checkbox v-model="withdrawal_enabled">
                Retrait autorisé
              </d-form-checkbox>
              <d-form-checkbox v-model="transfer_enabled">
                Transfert autorisé
              </d-form-checkbox>
              <d-form-checkbox v-model="payment_request_enabled">
                Paiement autorisé (RP)
              </d-form-checkbox>
            </d-col>
          </d-form-row>
        </div>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onSettingsFormSubmit"
                          :disabled="fetchingAccountSettings">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onSettingsModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par identifiant, nom ou tél..." v-model="search"/>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon">
              <i class="fa fa-search"></i>
            </template>
            Rechercher
          </c-button-spinner>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucun compte trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, Regex, Toast, truncate} from "@/helpers"
import TransactionsDumpMixin from "@/mixins/TransactionsDumpMixin"
import VueJsonCsv from "vue-json-csv"

export default {
  components: {VueJsonCsv},
  title: "Gestion des comptes",
  mixins: [TransactionsDumpMixin],
  data() {
    return {
      search: '',
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'name', label: 'Nom', sortable: true},
        {key: 'username', label: 'Identifiant', sortable: true},
        {key: 'phone_number_pretty', label: 'Num. de tél.', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'roles_pretty', label: 'Rôle(s)', sortable: true},
        {key: 'created_at', label: 'Inscrit le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      //table header
      verificationFields: [
        {key: 'reason_fr', label: 'Action'},
        {key: 'code', label: 'Code'},
        {key: 'email_or_phone', label: 'Email / N° tél.'},
        {key: 'created_at', label: 'Généré le'},
        {key: 'updated_at', label: 'Modifié le'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Transactions du compte",
          handler: this.onRedirectToTransaction
        },
        {type: 'white', icon: 'fa fa-file-excel', title: "Exporter les transactions", handler: this.onItemExport},
        {type: 'white', icon: 'fa fa-cog', title: "Paramètres du compte", handler: this.onItemSelectSettings},
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du compte", handler: this.onItemSelect},
      ],

      modalVisible: false,
      settingsModalVisible: false,

      selectedItem: null,

      roleList: [],

      birth_date: '',
      identity_expire_date: '',
      verified: false,
      enabled: true,
      roles: [],

      submitted: false,
      fetchingFormSubmit: false,

      fetchingAccountSettings: false,

      default_user_account_parameter: null,
      user_account_parameter_id: null,
      max_deposit_amount: '',
      max_deposit_amount_per_day: '',
      max_deposit_per_day: '',
      deposit_enabled: true,
      max_transfer_amount: '',
      max_transfer_amount_per_day: '',
      max_transfer_per_day: '',
      transfer_enabled: true,
      max_withdrawal_amount: '',
      max_withdrawal_amount_per_day: '',
      max_withdrawal_per_day: '',
      withdrawal_enabled: true,
      payment_request_enabled: true,

      account_parameters_templates: [],
      account_parameters_template: null,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return (item.first_name + ' ' + item.last_name).toLowerCase().includes(search)
          || item.username.toLowerCase().includes(search)
          || item.phone_number.includes(search)
          || item.email.includes(search)
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    name() {
      return this.itemSelected ? this.selectedItem.name : ''
    },
    first_name() {
      return this.itemSelected ? this.selectedItem.first_name : ''
    },
    last_name() {
      return this.itemSelected ? this.selectedItem.last_name : ''
    },
    username() {
      return this.itemSelected ? this.selectedItem.username : ''
    },
    phone_number() {
      return this.itemSelected ? formatAmount(this.selectedItem.phone_number) : ''
    },
    email() {
      return this.itemSelected ? this.selectedItem.email : ''
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ''
    },
    balance() {
      return this.itemSelected ? this.selectedItem.balance : ''
    },
    verificationData() {
      return !this.itemSelected ? [] : this.selectedItem.verification_data.map(el => ({
        ...el,
        email_or_phone: el.email || formatAmount(el.phone_number)
      }))
    },
    user_account_parameters_name() {
      return this.default_user_account_parameter ? this.default_user_account_parameter.name : '---'
    },
    max_deposit_amountState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_deposit_amount)
    },
    max_deposit_amount_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_deposit_amount_per_day)
    },
    max_deposit_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_deposit_per_day)
    },
    max_transfer_amountState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_transfer_amount)
    },
    max_transfer_amount_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_transfer_amount_per_day)
    },
    max_transfer_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_transfer_per_day)
    },
    max_withdrawal_amountState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_withdrawal_amount)
    },
    max_withdrawal_amount_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_withdrawal_amount_per_day)
    },
    max_withdrawal_per_dayState() {
      return !this.submitted || Regex.isPositiveNumber(this.max_withdrawal_per_day)
    },
  },
  watch: {
    account_parameters_template(settings) {
      if (settings)
        this.fillSettings(settings)
    }
  },
  created() {
    Api.get('/role/list')
      .then(res => this.roleList = res.data.roles)
      .catch(err => this.error = err)
      .then(() => null)

    Api.get('/account_parameter/list')
      .then(res => this.account_parameters_templates = res.data.account_parameters.map(settings => ({
        text: settings.name,
        value: settings
      })))
      .catch(err => this.error = err)
      .then(() => null)

    this.fetchingData = true
    Api.get('/user/list')
      .then(res => this.data = res.data.users.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        name: truncate(item.first_name + ' ' + item.last_name, 30) + (item.enabled ? '' : ' 🚫'),
        phone_number_pretty: formatAmount(item.phone_number),
        balance_pretty: formatAmount(item.balance),
        roles_pretty: item.roles.map(r => r.name).join(', '),
        status: item.verified ? "Vérifié" : item.kyc.identity_file1_path ? "En attente..." : "Non vérifié",
        statusVariant: item.verified ? "success" : item.kyc.identity_file1_path ? "warning" : "secondary",
        //to resolved error when making a search
        phone_number: item.phone_number ? item.phone_number : '',
        email: item.email ? item.email : '',
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.birth_date = item.birth_date
      this.identity_expire_date = item.kyc.identity_expire_date
      this.verified = item.verified
      this.enabled = item.enabled
      this.clearRoles()
      this.roles.push.apply(this.roles, item.roles.map(r => r.id))
      this.modalVisible = true
    },
    clearRoles() {
      this.roles.length = 0
    },
    clearFields() {
      this.birth_date = ''
      this.identity_expire_date = ''
      this.verified = false
      this.enabled = true
      this.clearRoles()
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return true
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/user/update', {
        user_id: this.selectedItem.id,
        birth_date: this.birth_date,
        identity_expire_date: this.identity_expire_date,
        verified: this.verified,
        enabled: this.enabled,
        roles: this.roles,
      })
        .then(res => {
          const user = this.mapItem(res.data.user)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, user)

          this.onModalClose()

          Toast.success(`L'utilisateur "${user.username}" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/user/find', {search: this.search})
        .then(res => this.data = res.data.users.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    fillSettings(settings) {
      if (!settings)
        return this.clearSettings()

      this.max_deposit_amount = settings.max_deposit_amount
      this.max_deposit_amount_per_day = settings.max_deposit_amount_per_day
      this.max_deposit_per_day = settings.max_deposit_per_day
      this.deposit_enabled = settings.deposit_enabled
      this.max_transfer_amount = settings.max_transfer_amount
      this.max_transfer_amount_per_day = settings.max_transfer_amount_per_day
      this.max_transfer_per_day = settings.max_transfer_per_day
      this.transfer_enabled = settings.transfer_enabled
      this.max_withdrawal_amount = settings.max_withdrawal_amount
      this.max_withdrawal_amount_per_day = settings.max_withdrawal_amount_per_day
      this.max_withdrawal_per_day = settings.max_withdrawal_per_day
      this.withdrawal_enabled = settings.withdrawal_enabled
      this.payment_request_enabled = settings.payment_request_enabled
    },
    onItemSelectSettings(item) {
      this.selectedItem = item
      this.settingsModalVisible = true

      this.fetchingAccountSettings = true
      Api.get('/user/parameters', {user_id: item.id})
        .then(res => {
          const data = res.data || {}
          this.default_user_account_parameter = data.account_parameter
          this.user_account_parameter_id = (data.parameters || {}).id
          this.fillSettings(data.parameters)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingAccountSettings = false)
      this.account_parameters_template = null
    },
    onSettingsModalClose() {
      this.settingsModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearSettings()
    },
    clearSettings() {
      this.account_parameters_template = null
      this.max_deposit_amount = ''
      this.max_deposit_amount_per_day = ''
      this.max_deposit_per_day = ''
      this.deposit_enabled = true
      this.max_transfer_amount = ''
      this.max_transfer_amount_per_day = ''
      this.max_transfer_per_day = ''
      this.transfer_enabled = true
      this.max_withdrawal_amount = ''
      this.max_withdrawal_amount_per_day = ''
      this.max_withdrawal_per_day = ''
      this.withdrawal_enabled = true
      this.payment_request_enabled = true

      this.user_account_parameter_id = null
    },
    isSettingsFormValid() {
      return Regex.isPositiveNumber(this.max_deposit_amount)
        && Regex.isPositiveNumber(this.max_deposit_amount_per_day) && Regex.isPositiveNumber(this.max_deposit_per_day)
        && Regex.isPositiveNumber(this.max_transfer_amount) && Regex.isPositiveNumber(this.max_transfer_amount_per_day)
        && Regex.isPositiveNumber(this.max_transfer_per_day) && Regex.isPositiveNumber(this.max_withdrawal_amount)
        && Regex.isPositiveNumber(this.max_withdrawal_amount_per_day) && Regex.isPositiveNumber(this.max_withdrawal_per_day)
    },
    onSettingsFormSubmit() {
      this.submitted = true

      if (!this.isSettingsFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/user/parameters/update', {
        user_id: this.selectedItem.id,
        account_parameter_id: (this.account_parameters_template || {}).id,
        user_account_parameter_id: this.user_account_parameter_id,
        max_deposit_amount: this.max_deposit_amount,
        max_deposit_amount_per_day: this.max_deposit_amount_per_day,
        max_deposit_per_day: this.max_deposit_per_day,
        deposit_enabled: this.deposit_enabled,
        max_transfer_amount: this.max_transfer_amount,
        max_transfer_amount_per_day: this.max_transfer_amount_per_day,
        max_transfer_per_day: this.max_transfer_per_day,
        transfer_enabled: this.transfer_enabled,
        max_withdrawal_amount: this.max_withdrawal_amount,
        max_withdrawal_amount_per_day: this.max_withdrawal_amount_per_day,
        max_withdrawal_per_day: this.max_withdrawal_per_day,
        withdrawal_enabled: this.withdrawal_enabled,
        payment_request_enabled: this.payment_request_enabled,
      })
        .then(res => {
          const user_name = this.name
          this.onSettingsModalClose()
          Toast.success(`Les paramètres du compte de "${user_name}" ont a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    //redirect a user account to its transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'USER', id: item.id}});
    },

    onExportFormSubmit() {
      this.submitted = true

      if (!this.isExportFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/user/dump', {
        user_id: this.selectedItem.id,
        transaction_type: this.export_transaction_type,
        transaction_status: this.export_transaction_status,
        from_datetime: this.export_from_datetime,
        to_datetime: this.export_to_datetime,
        format: this.export_format,
        separator: this.export_delimiter,
      })
        .then(res => {
          this.export_data = res.data.transactions
          if (!this.export_data.length)
            Toast.info("Aucune transaction trouvée")
          else {
            Toast.loading(`Génération du fichier ${this.export_format}...`)
            setTimeout(() => {
              Toast.loadingToast.goAway()
              this.$refs.csv.generate()
            }, 2000)
          }
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
  }
}
</script>

<style scoped>

</style>
